import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import Accordion from '../Accordion';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './SchoolProgramInfoSR.scss';
import SchoolInfoItem from '../SchoolInfoItem';
import { saveApplication } from '../../actions/saveApplication';
import { saveProgram } from '../../actions/saveProgram';
import messages from '../../locale/messages';
import analytics from '../../services/analytics';
import CursorIcon from '../icons/Cursor';
import TranslateIcon from '../icons/Translate';
import EmailIcon from '../icons/Email';
import PhoneIcon from '../icons/Phone';
import MortarboardIcon from '../icons/Mortarboard';
import CalendarOutlineIcon from '../icons/CalendarOutline';
import TimeIcon from '../icons/Time';
import LightBulbIcon from '../icons/LightBulb';
import UserIcon from '../icons/User';
import SchoolDataSimple from '../SchoolDataSimple';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const localMessages = defineMessages({
  programDataSpokenLangauge: {
    id: 'schoolinfo.programDataSpokenLangauge',
    defaultMessage: 'Languages spoken by providers',
    description: 'Languages spoken by providers',
  },
  providerInformation: {
    id: 'programinfo.providerInformation',
    defaultMessage: 'Provider Information',
    description: 'Provider Information',
  },
  providerWebsite: {
    id: 'programinfo.providerWebsite',
    defaultMessage: 'Provider Website',
    description: 'Provider Website',
  },
  providerEmail: {
    id: 'programinfo.providerEmail',
    defaultMessage: 'Provider Email',
    description: 'Provider Email',
  },
  providerPhone: {
    id: 'programinfo.providerPhone',
    defaultMessage: 'Provider Phone',
    description: 'Provider Phone',
  },
  siteContactEmail: {
    id: 'programinfo.siteContactEmail',
    defaultMessage: 'Site Contact Email',
    description: 'Site Contact Email',
  },
  siteContactPhone: {
    id: 'programinfo.siteContactPhone',
    defaultMessage: 'Site Contact Phone',
    description: 'Site Contact Phone',
  },
  siteInformation: {
    id: 'programinfo.siteInformation',
    defaultMessage: 'Site Information',
    description: 'Site Information',
  },
  programDescription: {
    id: 'programinfo.programDescription',
    defaultMessage: 'Program Overview',
    description: 'Program Overview',
  },
  accordionOtherFeatures: {
    id: 'programinfo.accordionOtherFeatures',
    defaultMessage: 'Program Features',
    description: 'Accordion label for program features',
  },
  portfolioId: {
    id: 'programinfo.portfolioId',
    defaultMessage: 'Portfolio ID',
    description: 'Label for Portfolio ID',
  },
  generalStringPriorityGroup: {
    id: 'programinfo.priorityGroup',
    defaultMessage: 'Admissions Priorities',
    description: 'which priority group you belong to',
  },
});

class SchoolProgramInfoSR extends PureComponent {
  static defaultProps = {
    description: '',
    start_date: null,
    end_date: null,
    start_time: null,
    hours: null,
    end_time: null,
    provider_website: null,
    provider_email: null,
    provider_phone_number: null,
    operating_weekdays: null,
    site_contact_name: null,
    site_contact_email: null,
    site_contact_phone_number: null,
    grades_description: null,
    other_features: [],
    languages_spoken_by_providers: [],
    portfolio_id: null,
  };
  static propTypes = {
    description: PropTypes.string,
    id: PropTypes.number.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    program: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    saveProgram: PropTypes.func.isRequired,
    saveApplication: PropTypes.func.isRequired,
    school: PropTypes.shape({
      name: PropTypes.string,
      dbn: PropTypes.string,
    }).isRequired,
    user: PropTypes.shape({
      applicationId: PropTypes.string.isRequired,
    }).isRequired,
    intl: PropTypes.shape().isRequired,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    start_time: PropTypes.string,
    end_time: PropTypes.string,
    hours: PropTypes.string,
    provider_website: PropTypes.string,
    provider_email: PropTypes.string,
    provider_phone_number: PropTypes.string,
    operating_weekdays: PropTypes.string,
    site_contact_name: PropTypes.string,
    site_contact_email: PropTypes.string,
    site_contact_phone_number: PropTypes.string,
    grades_description: PropTypes.string,
    other_features: PropTypes.arrayOf(PropTypes.shape({})),
    languages_spoken_by_providers: PropTypes.arrayOf(PropTypes.shape({})),
    portfolio_id: PropTypes.string,
    getPriorityGroups: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    let is_swd = false;
    let switches = null;
    if (props.loggedIn) {
      switches = props.switchsGeSwd || props.switches;
      is_swd = switches && switches.show_GE_SWD_toggle_on_application_program_admissions && switches.is_swd
    }

    this.state = {
      isSWDSelected: switches && switches.is_swd,
      showGEDemandSection: !is_swd,
      showSWDDemandSection: is_swd
    };
  }
  accordionClick = accordionLabel => {
    const { school, program, loggedIn } = this.props;
    const { code, name } = program;
    let dataDictionary = {
      accordionLabel: accordionLabel,
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn: loggedIn ? true : false
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = this.props;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: 'programAccordionOpen',
      dataDictionary: dataDictionary
    });
  };

  renderPreference = () => {
    const { preference, intl } = this.props;
    if (preference) {
      return (
        <Fragment>
          <div className={style.priorityGroupsHeader}>
            {intl.formatMessage(messages.preferencesTitle)}
          </div>
          <div>
            <p className={style.admissionsProcessText}>{this.props.preference}</p>
          </div>
        </Fragment>
      );
    }
    return null;
  };
  renderPriorityGroup = () => {
    const { getPriorityGroups, admissionMethod, preference, user, intl } = this.props;
    const isLimitedUnscreened = admissionMethod.name === 'Limited Unscreened';
    const { all, forStudent } = getPriorityGroups();
    const isLoggedInHsMS = user.isMS || user.isHS;
  
    if (!all || (all.filter(priority => priority.name).length === 0 && !preference)) {
      return null;
    } else if (!all || all.filter(priority => priority.name).length === 0) {
      return <div className={style.priorityGroups}>{this.renderPreference()}</div>;
    }

    let show_priority_group_info = false;
    if (this.props.loggedIn) {
      const switches = this.props.switchsGeSwd || this.props.switches;
      show_priority_group_info = !isLoggedInHsMS || switches.show_GE_SWD_toggle_on_application_program_admissions || switches.show_GE_SWD_toggle_on_public_program_admissions
    }

    const priorityGroups = all.map(priority => {
      // let description;
      // if (this.state.isSWDSelected) {
      //   description = priority.swd_priority_group_description;
      // } else {
      //   description = priority.ge_priority_group_description;
      // }
      return (
        <li className={style.priorityGroupListItem} key={`priority-accordion-${priority.id}`}>
          <div>{priority.name}</div>
          {/* {priority.ge_priority_group_description && <div>({priority.ge_priority_group_description})</div>} */}
        </li>
      );
    });
    
    return (
      <Accordion
        label={intl.formatMessage(localMessages.generalStringPriorityGroup)}
        analytics={this.accordionClick}>
          {isLimitedUnscreened && (
          <div className={style.limitedUnscreenedMessage}>
            {intl.formatMessage(messages.schoolProgramLimitedUnscreened)}
          </div>
        )}
        <ol className={style.priorityGroupsList}>{priorityGroups}</ol>
        {this.props.lowest_priority && <p className={style.admissionsProcessText}>{this.props.lowest_priority}</p>}
        {this.renderPreference()}
      </Accordion>
    );
  };
  render() {
    const {
      languages_spoken_by_providers,
      site_contact_email,
      site_contact_name,
      site_contact_phone_number,
      hours,
      start_date,
      operating_weekdays,
      end_date,
      grades_description,
      intl,
      provider_website,
      provider_email,
      provider_phone_number,
      description,
      other_features,
      program,
      portfolio_id,
    } = this.props;

    let startDate = start_date ? moment(start_date).format('MMM DD, YYYY') : null;
    let endDate = end_date ? moment(end_date).format('MMM DD, YYYY') : null;
    let dates = start_date && end_date ? `${startDate} - ${endDate}` : null;
    let providerWebsite = provider_website;
    if (provider_website && provider_website.indexOf('http://') === -1 && provider_website.indexOf('https://') === -1) {
      providerWebsite = `https://${provider_website}`;
    }
    let languages = null;
    if (languages_spoken_by_providers && languages_spoken_by_providers.length > 0)
      languages = languages_spoken_by_providers.map(item => item.name).join(', ');
    let otherFeaturesList = null;
    if (other_features && other_features.length > 0) {
      otherFeaturesList = other_features.map(item => <li key={item.name}>{item.name}</li>);
    }
    let renderContactInformation = site_contact_name || site_contact_email || site_contact_phone_number || providerWebsite || provider_email || provider_phone_number;
    let priorityGroup = null
    if (this.renderPriorityGroup()){
      priorityGroup = (<div>{this.renderPriorityGroup()}</div>);}

    return (
      <div className={style.accordionContainer}>      
        <div className={style.mainRow}>
          {(grades_description || operating_weekdays) && (<div className={style.blockRow}>
            {grades_description && (
              <SchoolInfoItem
                icon={
                  <MortarboardIcon
                    ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringGradeRange)}
                    size={18}
                  />
                }
              >
                {grades_description}
              </SchoolInfoItem>
            )}
            {operating_weekdays && (
              <SchoolInfoItem
                icon={
                  <CalendarOutlineIcon
                    ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringGradeRange)}
                    size={18}
                  />
                }
              >
                {operating_weekdays}
              </SchoolInfoItem>
            )}
          </div>)}
          {(dates || hours) && (
            <div className={style.blockRowNoMargin}>
              {dates && (
                <SchoolInfoItem
                  icon={
                    <CalendarOutlineIcon
                      size={18}
                      ariaLabel={customisedIntlFormatMessage(intl, messages.iconTime)}
                    />
                  }
                >
                  {dates}
                </SchoolInfoItem>
              )}
              {hours && (
                <SchoolInfoItem
                  icon={
                    <TimeIcon
                      size={18}
                      ariaLabel={customisedIntlFormatMessage(intl, messages.iconTime)}
                    />
                  }
                >
                  {hours}
                </SchoolInfoItem>
              )}
            </div>
          )}
        </div>
        {languages && (
          <div className={style.row}>
            <SchoolInfoItem
              icon={
                <TranslateIcon
                  ariaLabel={customisedIntlFormatMessage(intl, localMessages.programDataSpokenLangauge)}
                  size={18}
                />
              }
            >
              {languages}
            </SchoolInfoItem>
          </div>
        )}
        {renderContactInformation && (
          <Accordion
            superLabel={customisedIntlFormatMessage(intl, messages.generalStringContactInformation)}
            label=""
            analytics={this.accordionClick}
          >
            {(providerWebsite || provider_email || provider_phone_number) && (
              <Accordion isSummerRising={true} label={customisedIntlFormatMessage(intl, localMessages.providerInformation)} analytics={this.accordionClick}>
                {providerWebsite && (
                  <div className={style.internalRow}>
                    <SchoolInfoItem
                      icon={
                        <CursorIcon
                          size={18}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.iconCursor)}
                        />
                      }
                    >
                      <a
                        target="_blank"
                        rel="noopener"
                        href={`${providerWebsite}`}
                        aria-label={customisedIntlFormatMessage(intl, localMessages.providerWebsite)}
                      >
                        {providerWebsite}
                      </a>
                    </SchoolInfoItem>

                  </div>
                )}
                {provider_email && (
                  <div className={style.internalRow}>
                    <SchoolInfoItem
                      icon={
                        <EmailIcon
                          size={18}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.iconEmail)}
                        />
                      }
                    >
                      <a href={`mailto:${provider_email}`} aria-label={customisedIntlFormatMessage(intl, localMessages.providerEmail)}>
                        {provider_email}
                      </a>
                    </SchoolInfoItem>
                  </div>
                )}
                {provider_phone_number && (
                  <div className={style.internalRow}>
                    <SchoolInfoItem
                      icon={
                        <PhoneIcon
                          size={18}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.iconPhone)}
                        />
                      }
                    >
                      <a href={`tel:${provider_phone_number}`} aria-label={customisedIntlFormatMessage(intl, localMessages.providerPhone)}>
                        {provider_phone_number}
                      </a>
                    </SchoolInfoItem>
                  </div>
                )}
              </Accordion>
            )}

            {(site_contact_name || site_contact_email || site_contact_phone_number) && (
              <Accordion isSummerRising={true} label={customisedIntlFormatMessage(intl, localMessages.siteInformation)} analytics={this.accordionClick}>
                {site_contact_name && (
                  <div className={style.internalRow}>
                    <SchoolInfoItem
                      icon={
                        <UserIcon
                          size={18}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.iconContactName)}
                        />
                      }
                    >
                      <div dangerouslySetInnerHTML={{ __html: site_contact_name }}></div>
                    </SchoolInfoItem>
                  </div>
                )}
                {site_contact_email && (
                  <div className={style.internalRow}>
                    <SchoolInfoItem
                      icon={
                        <EmailIcon
                          size={18}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.iconEmail)}
                        />
                      }
                    >
                      <a href={`mailto:${site_contact_email}`} aria-label={customisedIntlFormatMessage(intl, localMessages.siteContactEmail)}>
                        {site_contact_email}
                      </a>
                    </SchoolInfoItem>
                  </div>
                )}
                {site_contact_phone_number && (
                  <div className={style.internalRow}>
                    <SchoolInfoItem
                      icon={
                        <PhoneIcon
                          size={18}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.iconPhone)}
                        />
                      }
                    >
                      <a href={`tel:${site_contact_phone_number}`} aria-label={customisedIntlFormatMessage(intl, localMessages.siteContactPhone)}>
                        {site_contact_phone_number}
                      </a>
                    </SchoolInfoItem>
                  </div>)}
              </Accordion>
            )}
          </Accordion>
        )}
        {description && (
          <Accordion isSummerRising={true} label={customisedIntlFormatMessage(intl, localMessages.programDescription)} analytics={this.accordionClick}>
            <div className={style.row}>
              {description}
            </div>
          </Accordion>
        )}
        {otherFeaturesList && (
          <Accordion isSummerRising={true} label={customisedIntlFormatMessage(intl, localMessages.accordionOtherFeatures)} analytics={this.accordionClick}>
            <div className={style.schoolDataWrapper}>
              <ul className={style.disc}>{otherFeaturesList}</ul>
            </div>
          </Accordion>
        )}
       {priorityGroup}
       {/* {priorityGroup && (<Accordion
          label={intl.formatMessage(messages.generalStringAdditionalInformation)}
          analytics={this.accordionClick}
        >{priorityGroup}
        </Accordion>)} */}
        <Accordion
          label={customisedIntlFormatMessage(intl, messages.generalStringAdditionalInformation)}
          analytics={this.accordionClick}
        >
          <div className={style.programDataWrapper}>
            {program.code && (
              <SchoolDataSimple title={customisedIntlFormatMessage(intl, messages.generalStringProgramCode)} stat={program.code} />
            )}
          </div>
          {portfolio_id && (
            <div className={style.programDataWrapper}>
                <SchoolDataSimple title={customisedIntlFormatMessage(intl, localMessages.portfolioId)} stat={portfolio_id} />
            </div>
          )}
        </Accordion>
      </div>
    );
  }
}

const mapState = ({ user }) => ({ user });
const mapDispatch = {
  saveProgram,
  saveApplication,
};

export { SchoolProgramInfoSR };
export default injectIntl(
  connect(
    mapState,
    mapDispatch,
  )(withStyles(style)(SchoolProgramInfoSR)),
);
